import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {OrganizationSelect} from 'components/forms';
import styles from './styles.css';

export default class User extends Component {
    static propTypes = {
        user: PropTypes.object,
        vertical: PropTypes.bool,
        onSessionOrganizationChange: PropTypes.func,
        background: PropTypes.bool,
    };

    render() {
        return (
            <div className={classNames(styles.root, {
                [styles.vertical]: this.props.vertical,
                [styles.horizontal]: !this.props.vertical,
            })}>
                <div className={styles.organization}>
                    {this.props.onSessionOrganizationChange ? (
                        <OrganizationSelect
                            value={this.props.user.organization.id}
                            onChange={this.props.onSessionOrganizationChange}
                            clearable={false}
                            variables={{includeOwn: true}}
                            background={this.props.background}
                        />
                    ) : (
                        this.props.user.organization.name
                    )}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/header/user/index.js